let DefaultSeatIcons = [
    {
        srt_id: 1,
        srt_dash_image_url: '/icons/seatIcons/1-regularseat.png',
        srt_online_image_url: '/icons/seatIcons/online_available.png',
        srt_pos_image_url: '/icons/seatIcons/1-regularseat.png',

        srt_dash_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',
        srt_online_image_url_selected: '/icons/seatIcons/online_selected_seat.png',
        srt_pos_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/block_seat.png',
        srt_online_image_url_disabled: '/icons/seatIcons/online_unavailable.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/block_seat.png',
    },
    {
        srt_id: 2,
        srt_dash_image_url: '/icons/seatIcons/2-no-seat.png',
        srt_online_image_url: '/icons/seatIcons/online_available.png',
        srt_pos_image_url: '/icons/seatIcons/2-no-seat.png',

        srt_dash_image_url_selected: '/icons/seatIcons/2-no-seat.png',
        srt_online_image_url_selected: '/icons/seatIcons/online_selected_seat.png',
        srt_pos_image_url_selected: '/icons/seatIcons/2-no-seat.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/2-no-seat.png',
        srt_online_image_url_disabled: '/icons/seatIcons/online_unavailable.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/2-no-seat.png',
    },
    {
        srt_id: 3,
        srt_dash_image_url: '/icons/seatIcons/3-wheelChair.png',
        srt_online_image_url: '/icons/seatIcons/online_available.png',
        srt_pos_image_url: '/icons/seatIcons/3-wheelChair.png',

        srt_dash_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',
        srt_online_image_url_selected: '/icons/seatIcons/online_selected_seat.png',
        srt_pos_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/block_seat.png',
        srt_online_image_url_disabled: '/icons/seatIcons/online_unavailable.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/block_seat.png',
    },
    {
        srt_id: 4,
        srt_dash_image_url: '/icons/seatIcons/1-house-seat-normal.png',
        srt_online_image_url: '/icons/seatIcons/1-house-seat-normal.png',
        srt_pos_image_url: '/icons/seatIcons/1-house-seat-normal.png',

        srt_dash_image_url_selected: '/icons/seatIcons/1-house-seat-selected.png',
        srt_online_image_url_selected: '/icons/seatIcons/1-house-seat-selected.png',
        srt_pos_image_url_selected: '/icons/seatIcons/1-house-seat-selected.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/1-house-seat-blocked.png',
        srt_online_image_url_disabled: '/icons/seatIcons/1-house-seat-blocked.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/1-house-seat-blocked.png',
    },
    {
        srt_id: 5,
        srt_dash_image_url: '/icons/seatIcons/vip_seat.png',
        srt_online_image_url: '/icons/seatIcons/online_available.png',
        srt_pos_image_url: '/icons/seatIcons/vip_seat.png',

        srt_dash_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',
        srt_online_image_url_selected: '/icons/seatIcons/online_selected_seat.png',
        srt_pos_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/block_seat.png',
        srt_online_image_url_disabled: '/icons/seatIcons/online_unavailable.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/block_seat.png',
    },
    {
        srt_id: 9,
        srt_dash_image_url: '/icons/seatIcons/9-icon-poin-of-sale.png',
        srt_online_image_url: '/icons/seatIcons/online_available.png',
        srt_pos_image_url: '/icons/seatIcons/9-icon-poin-of-sale.png',

        srt_dash_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',
        srt_online_image_url_selected: '/icons/seatIcons/online_selected_seat.png',
        srt_pos_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/block_seat.png',
        srt_online_image_url_disabled: '/icons/seatIcons/online_unavailable.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/block_seat.png',
    },
    {
        srt_id: 10,
        srt_dash_image_url: '/icons/seatIcons/10-icon-sofa-dark.png',
        srt_online_image_url: '/icons/seatIcons/online_available.png',
        srt_pos_image_url: '/icons/seatIcons/10-icon-sofa-dark.png',

        srt_dash_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',
        srt_online_image_url_selected: '/icons/seatIcons/online_selected_seat.png',
        srt_pos_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/block_seat.png',
        srt_online_image_url_disabled: '/icons/seatIcons/online_unavailable.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/block_seat.png',
    },
    {
        srt_id: 11,
        srt_dash_image_url: '/icons/seatIcons/11-recliner.png',
        srt_online_image_url: '/icons/seatIcons/online_available.png',
        srt_pos_image_url: '/icons/seatIcons/11-recliner.png',

        srt_dash_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',
        srt_online_image_url_selected: '/icons/seatIcons/online_selected_seat.png',
        srt_pos_image_url_selected: '/icons/seatIcons/selected_seat_pos_green.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/block_seat.png',
        srt_online_image_url_disabled: '/icons/seatIcons/online_unavailable.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/block_seat.png',
    },
    {
        srt_id: 12,
        srt_dash_image_url: '/icons/seatIcons/block_seat.png',
        srt_online_image_url: '/icons/seatIcons/online_available.png',
        srt_pos_image_url: '/icons/seatIcons/block_seat.png',

        srt_dash_image_url_selected: '/icons/seatIcons/block_seat.png',
        srt_online_image_url_selected: '/icons/seatIcons/online_selected_seat.png',
        srt_pos_image_url_selected: '/icons/seatIcons/block_seat.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/block_seat.png',
        srt_online_image_url_disabled: '/icons/seatIcons/online_unavailable.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/block_seat.png',
    },
    {
        srt_id: 13,
        srt_dash_image_url: '/icons/seatIcons/13-broken-seat.png',
        srt_online_image_url: '/icons/seatIcons/online_available.png',
        srt_pos_image_url: '/icons/seatIcons/13-broken-seat.png',

        srt_dash_image_url_selected: '/icons/seatIcons/13-broken-seat.png',
        srt_online_image_url_selected: '/icons/seatIcons/online_selected_seat.png',
        srt_pos_image_url_selected: '/icons/seatIcons/13-broken-seat.png',

        srt_dash_image_url_disabled: '/icons/seatIcons/13-broken-seat.png',
        srt_online_image_url_disabled: '/icons/seatIcons/online_unavailable.png',
        srt_pos_image_url_disabled: '/icons/seatIcons/13-broken-seat.png',
    },
]

export const getDefaultSeatIcons = (srt_id) => {
    let srtObj = {}
    let srtObjTemp = {
        srt_dash_image_url: null,
        srt_online_image_url: null,
        srt_pos_image_url: null,

        srt_dash_image_url_selected: null,
        srt_online_image_url_selected: null,
        srt_pos_image_url_selected: null,

        srt_dash_image_url_disabled: null,
        srt_online_image_url_disabled: null,
        srt_pos_image_url_disabled: null
    }        
    srtObj = DefaultSeatIcons.find((x) => x.srt_id == srt_id)
    if(srtObj) {
        return srtObj;
    } else {
        return srtObjTemp;
    }
};


// WEBPACK FOOTER //
// ./src/helper/seatReservationTypeHelper.js